import React from 'react';
import Box from '../../components/Box';
import Footer from '../../containers/Footer';
import {useAppBarHeight} from '../../hooks';

const withLegal =
  (Component: React.ElementType) =>
  ({...props}) => {
    const appBarHeight = useAppBarHeight();

    return (
      <React.Fragment>
        <Box mt={`${appBarHeight}px`}>
          <Component {...props} />
        </Box>

        <Footer />
      </React.Fragment>
    );
  };

export default withLegal;
